'use client';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import s from './Toolbar.module.scss';
import Icon from '../Icon';
import Popover from '../Popover/Popover';
import AccountMenu from './AccountMenu';

const Toolbar = ({
    user = {
        name: '',
    },
    logoutUrl,
    clientDashboards = [],
}) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);

    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsPopoverOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={s.Root}>
            <Popover
                onClick={togglePopover}
                isPopoverOpen={isPopoverOpen}
                popoverRef={popoverRef}
                minWidth="23.8rem"
                modifier="RightAligned"
                content={
                    <AccountMenu
                        user={user}
                        dashboards={clientDashboards}
                        logoutUrl={logoutUrl}
                    />
                }>
                <div className={s.UserWrapper}>
                    <div className={s.Button}>
                        <Icon name="UserProfile" />
                        <span className={s.UserName}>{user.name}</span>
                        <Icon name="MoreVertical" />
                    </div>
                </div>
            </Popover>
        </div>
    );
};

Toolbar.propTypes = {
    user: PropTypes.object,
    logoutUrl: PropTypes.string,
    clientDashboards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            url: PropTypes.string,
            title: PropTypes.string,
            isActive: PropTypes.bool,
            listImage: PropTypes.object,
        })
    ),
};

export default Toolbar;
